import socket from 'socket.io-client';
import config from './config';

const io = socket(config.url);

export default io;